export default "__VITE_ASSET__d5221918__"